import type * as React from "react";
import { useFormContext } from "react-hook-form";
import type { ZodBoolean } from "zod";

interface FormCheckboxProps {
	formKey: string;
	schema: ZodBoolean;
	isDisabled?: boolean;
}

const FormCheckbox: React.FC<FormCheckboxProps> = ({ formKey, isDisabled }) => {
	const { register } = useFormContext();

	return (
		<input
			type="checkbox"
			id={formKey}
			disabled={isDisabled}
			className="appearance-none! checkbox laptop:size-4.5 size-4 rounded-md checked:bg-sky-500 checked:text-white disabled:cursor-not-allowed disabled:opacity-40 dark:checked:bg-sky-600"
			{...register(formKey)}
		/>
	);
};

export default FormCheckbox;
